import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { CustomTable, Text } from '../../../shared/uiComponents';
import { Users } from '../../../shared/Assets/menuIcons';
import { Loader } from '../../../components/StyledComponents';
import { MobileViewAdmin } from '../MobileView';
import { TableBodyAuthorization } from '../Admin/tableInfo';
import { AUTHORIZATION_HEADERS, AuthorizationStatusInfo } from '../helpers';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getAuthorizationInfoClinicalSupervisor } from '../../../redux/State/clientSlice/dashboardSlice';

const AuthorizationsInfo = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const loading = useSelector((state) => state.dashboard.loading);
	const userId = useSelector((state) => state.account.user.id);
	const authorization = useSelector((state) => state.dashboard.authorizations);

	useEffect(() => {
		if (!userId) return;
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		dispatch(
			getAuthorizationInfoClinicalSupervisor({
				data: {
					page,
					pageSize,
				},
				userId,
			}),
		);
	}, [params, userId, dispatch]);

	if (loading) return <Loader />;

	return authorization.query?.length ? (
		<div className="dashboardCard">
			<div className="dashboardHeader">
				<div className="header">
					<div className="headerIcon">
						<Users />
					</div>
					<Text type="h6" font="header" fontWeight="semiBold" title="Authorizations" />
				</div>
				<AuthorizationStatusInfo />
			</div>
			<CustomTable
				headers={AUTHORIZATION_HEADERS}
				data={authorization}
				TableBody={TableBodyAuthorization}
				loading={loading}
			/>
			<MobileViewAdmin data={authorization} />
		</div>
	) : null;
};

export default AuthorizationsInfo;
